






















































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
    name: 'UseCard',
})
export default class UseCard extends Vue {
    @Prop(Number) private id: number;
    @Prop(String) private email: string;
    @Prop(String) private userName: string;

    private get nickName(): string {
        return `${
            this.userName.split(' ')[0] +
            this.userName.split(' ')[1].slice(0, 2)
        }`;
    }

    private get isWoman(): boolean {
        return this.id === 1 || this.id === 3 ? true : false;
    }
}
